var path = 'event/event-row-stats.tpl.html';
var html = "\n<div class=\"tb-cell\" flex>{{event.createdTime | date :  'yyyy-MM-dd HH:mm:ss'}}</div>\n<div class=\"tb-cell\" flex>{{event.body.server}}</div>\n<div class=\"tb-cell tb-number\" flex>{{event.body.messagesProcessed}}</div>\n<div class=\"tb-cell tb-number\" flex>{{event.body.errorsOccurred}}</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/event/event-row-stats.tpl.html
// module id = 1487
// module chunks = 1